export { Highlighter as default } from './Highlighter';